<template>
    <div class="container feedback template-bg-gray"  v-bind:class="{'my-position-relative': isStatus}">
        <md-card class="request-status loop_container bg-transparent update-request-form-common" v-if="isStatus">
            <md-card-content class="col-lg-12 col-md-12 col-sm-12 col-xs-12 main">
                <div class="card form-wrapper text-center p-20">
                    <h4 class="template-custom-title" v-html="statusMsg"></h4>
                </div>
            </md-card-content>
        </md-card>
        <div class="row" v-if="!isStatus">
            <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 main-sec">
                <div class="loop_container bg-transparent update-request-form-common">
                    <div class="card form-wrapper" v-bind:class="{'thankupageplr88': success}">
                        <div class="feedback_container">
                            <div class="row">
                                <div class="col-md-12 text-center">
                                    <img :src="logoURL" class="top-logo custom-logo" :alt="community.content && community.content.parameter2 ? community.content.parameter2 : 'Community Logo'">
                                </div>
                            </div>
                            <div class='header-text common-space-from-logo' v-bind:class="{'email-actionpage-tmsg plr10': !success}">
                                <h1 class="template-title text-center">Thank you!</h1>
                                <p class="custom-content" v-if="!success">Tell us briefly (confidentially) why you have not engaged further. We want to do a better job setting expectations.</p>
                            </div>
                            <form @submit.prevent="submitFollowup()" v-show="!success" class="template-form">
                                <div class="row">
                                    <div class="col-md-12">
                                        <div :class="[{'b-error' : errors.has('comment')}, 'form-group', 'pd-remove', 'unsubscribe-height']" class="template-input-text-area">
                                            <textarea
                                                class="form-control"
                                                name="comment"
                                                id="comment"
                                                rows="10"
                                                v-model="comment"
                                                :placeholder="commentPlaceholder"
                                                v-validate.continues="'required|max:500'"
                                                :maxlength="max"
                                                v-bind:class="{'request-form-error-border': errors.has('comment') }"
                                                @input="sanitizeComment"
                                                v-focus
                                                >
                                            </textarea>
                                            <p class="error" v-show="errors.has('comment')">{{errors.first('comment')}}</p>
                                        </div>
                                    </div>
                                </div>
                                <div class="row">
                                    <div class="col-md-12 text-right">
                                        <div class="form-group pd-remove unsubscribe-btn">
                                            <button type="submit"
                                                name="helpAction"
                                                v-bind:style="reviewBtn"
                                                class="btn template-button btn_info bg-white">Submit</button>
                                        </div>
                                    </div>
                                </div>
                            </form>
						</div>
                    </div>
                    <ul class="list-inline text-center footer-links">
                        <li>
                            <a :href="community.content.landingPageURL" target="_blank" class="links" v-if="community.content && community.content.landingPageURL && community.content.landingPageURL.length" tabindex="0">Learn More</a>
                            <a href="javascript:void(0)" v-else tabindex="0">Learn More</a>
                        </li>
                        <li>
                            <a :href="community.content.termsConditionsURL" target="_blank" class="links" v-if="community.content && community.content.termsConditionsURL && community.content.termsConditionsURL.length" tabindex="0">Terms Of Use [pdf]</a>
                            <a href="javascript:void(0)" v-else tabindex="0">Terms Of Use [pdf]</a>
                        </li>
                        <li>
                            <a tabindex="0" :href="community.content.unsubscribePageURL" target="_blank" v-if="community.content && community.content.unsubscribePageURL && community.content.unsubscribePageURL.length">Opt Out</a>
                            <a href="javascript:void(0)" v-else>Opt Out</a>
                        </li>
                    </ul>
                    <div class="unsubscribe-community-logo">
                        <a href="https://www.protopia.co" target="_blank"><img :src="footerLogoURL" alt='Community Logo'></a>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import API from "../services/API";
import { sanitizeInput } from '../utils/sanitizer';
import { getFooterURL, getLogoURL } from "../helpers/getCustomSettings";
export default {
    props: ["askid", "giveid", "helpaction"],
    data() {
        return {
			api: new API(),
			ask: {},
			community: {},
			comment: "",
            fullPage: true,
			success: false,
			max: 500,
			commentPlaceholder: "I have not followed up because ...",
			reviewBtn: {
                border: '1px solid #9178A0',
                color: '#9178A0'
            },
            isStatus: true,
            statusMsg: '',
            logoURL: "",
            footerLogoURL: ""
        };
    },
    created() {
        if (!this.askid || !this.giveid || !this.helpaction) {
            this.$router.push('/');
        }
        this.loadData();
        const dict = {
      	    custom: {
      		    comment: {
      		        required: 'Please enter your response follow-up reason'
                }
      		}
      	};
     	this.$validator.localize('en', dict);
    },
    methods: {
        sanitizeComment(e) {
            this.comment = sanitizeInput(e.target.value);
        },
        loadData: async function() {
            await this.api.get(`asks/${this.askid}`).then(async ask => {
                this.ask = ask.data;
                if (this.ask.status === '(8) Rejected' || this.ask.status === '(7) Closed') {
                    // console.log("this.community :", this.ask.community);
                    let closeMessage = this.ask.community.content.closeRequestMessage;
                    this.statusMsg = closeMessage;
                } else {
                    this.isStatus = false;
                }
                if (this.ask) {
                    if (this.helpaction === 'yes') {
                        document.title = 'Thank You';
                        this.success = true;
                        this.updateFollowUp('yes');
                    }
                    this.community = this.ask.community;
                    const customSettings = this.community.customSettings;
                    this.logoURL = getLogoURL(customSettings);
                    this.footerLogoURL = getFooterURL(customSettings);
                    window.scrollTo(0, 0);
                    setTimeout(function() {
                        document.getElementById("comment").focus();
                    }, 0);
                }
            });
        },
        submitFollowup: async function() {
            this.$validator.validateAll().then(async result => {
                if (result) {
                    await this.updateFollowUp('no');
                }
            });
        },
        updateFollowUp: async function(action) {
            document.title = 'Thank You';
            this.success = true;
            window.scrollTo(0, 0);
            await this.api.post(`asks/${this.askid}/add-response-follow-up`, { giveid: this.giveid, comment: this.comment, helpaction: action }).then(response => {
                if (response.data.error) {
                    this.$validator.reset();
                    this.comment = '';
                    return this.$toast.error(response.data.error);
                }
            });
        }
    }
}
</script>



// WEBPACK FOOTER //
// src/components/ResponseFollowUp.vue